import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CreateRecycleFolder,
    DeleteDriveFolderIrreversibly,

    setDriveAction,
    clearDriveSelection,
    reloadDriveLists,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    SpinnerIcon,
} from "client/components"


const ClearRecycle = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const onCancel = () => {
        dispatch(setDriveAction(null))
    }

    const onConfirm = () => {
        setDeleteState(PENDING)
        const recycle = CreateRecycleFolder(lang)

        DeleteDriveFolderIrreversibly(recycle, false, userData, lang).then(() => {
            setDeleteState(IDLE)

            clearDriveSelection(dispatch)
            reloadDriveLists(dispatch)
        })
    }

    return (
        <ConfirmWrapper show onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{lang.emptyRecycleBin}</ConfirmTitle>
                <ConfirmDescription>{lang.emptyRecycleBinConfirm}</ConfirmDescription>
                <ConfirmBottom>
                    <Button variant="success" row onClick={onConfirm}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ClearRecycle
